import { z } from 'zod';
/** Error envelope returned by every API failure (apps/api/src/platform/http/error-handler.ts). */
export const apiErrorSchema = z.object({
    error: z
        .object({
        code: z.string(),
        message: z.string(),
        request_id: z.string().nullable(),
        fields: z.record(z.string(), z.array(z.string())).optional(),
        retry_after: z.number().optional(),
        feature: z.string().optional(),
    })
        .loose(),
});
//# sourceMappingURL=errors.js.map